<template>
  <NText class="whitespace-pre-line px-3" variant="caption2">
    <i18n-t
      scope="global"
      keypath="modules.portfolio.bonusShareDialogDesription"
      tag="span"
    >
      <template #symbolName>
        <NText variant="caption2">
          {{ symbolName }}
        </NText>
      </template>
      <template #quantity>
        <NText variant="caption2">
          {{ quantity }}
        </NText>
      </template>

      <template #not_sellable>
        <NText variant="caption2" weight="bold">
          {{ t('modules.portfolio.bonusShareDialogDesription_not_sellable') }}
        </NText>
      </template>
      <template #exact>
        <NText variant="caption2" weight="bold">
          {{ t('modules.portfolio.bonusShareDialogDesription_exact') }}
        </NText>
      </template>
      <template #at_least>
        <NText variant="caption2" weight="bold">
          {{ t('modules.portfolio.bonusShareDialogDesription_at_least') }}
        </NText>
      </template>
      <template #change>
        <NText variant="caption2" weight="bold">
          {{ t('modules.portfolio.bonusShareDialogDesription_change') }}
        </NText>
      </template>
    </i18n-t>
  </NText>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

type TBonusShareProps = {
  symbolName: string;
  quantity: number;
};

defineProps<TBonusShareProps>();

const { t } = useI18n();
</script>
